export const LINE_CHART_DATA_POINT_WIDTH = 90
export const BAR_CHART_DATA_POINT_WIDTH = 80
